import { render, staticRenderFns } from "./vzcoupon.vue?vue&type=template&id=1cdaedaf&scoped=true&"
import script from "./vzcoupon.vue?vue&type=script&lang=js&"
export * from "./vzcoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdaedaf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cdaedaf')) {
      api.createRecord('1cdaedaf', component.options)
    } else {
      api.reload('1cdaedaf', component.options)
    }
    module.hot.accept("./vzcoupon.vue?vue&type=template&id=1cdaedaf&scoped=true&", function () {
      api.rerender('1cdaedaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Homelive/components/vzcoupon.vue"
export default component.exports